import React from 'react'
import AddUploadFile from './AddUploadFile'
import {Button} from "antd";
import "./index.scss"
export default class UploadFileNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filename: '',
        }
        this.onChange = this.onChange.bind(this)
        this.clearFileName = this.clearFileName.bind(this)
    }

    onChange(filename,selectName) {
        this.setState({
            filename: filename,
            selectName
        })
        this.props.onChange(filename)
    }

    clearFileName() {
        this.setState({
            filename: ''
        })
    }

    render() {
        const {filename,selectName} = this.state;
        const {result,fileName,downloadTemplate,onError} = this.props;
        return <div className="upload_new_content">
            <div className="upload_new">
                {!filename ?
                    <div className="upload_row" >
                        <AddUploadFile {...this.props}
                                       callBackFunc={(filename,selectName) => this.onChange(filename,selectName)}/>
                        <span className="upload_tip">
                {Strings.uploadTips || "上传完善好的内容，支持上传的文件格式："}{this.props.extensions ? this.props.extensions : 'xls、xlsx、csv'}
                    </span>
                    </div> :
                    <div className="upload_filename_row">
                        <span className="filename">{selectName}</span>
                        <a onClick={() => this.onChange('')}>
                            <i className="icon shanchu"/>
                        </a>
                    </div>
                }

            </div>
            {result ? <div className="mgt23" style={{display:"flex",justifyContent:"center"}}>
                    <a style={{color: "red"}} onClick={onError}>{result}</a>
                </div>
                : ""}
            <div className="right_btn_row mgt10">
                <Button className="download_template_btn" onClick={downloadTemplate}>
                    <i className="icon mobanxiazai"/>
                    {Strings.downTpls || "下载模板"}
                </Button>
            </div>
        </div>
    }

}